export default __webpack_public_path__ + "static/media/likelihood-rating.f24fb7ed.png";